import { AssetStatus, TenantStatusCopy } from "@hydrologiq/gql-experience/graphql"

export function statusToText(status: AssetStatus, copy: TenantStatusCopy[] = []) {
  const copyStatus = copy.find((c) => c.status === status)
  if (copyStatus) {
    return copyStatus.value
  }
  switch (status) {
    case AssetStatus.Available:
      return "Available"
    case AssetStatus.Servicing:
      return "Servicing"
    case AssetStatus.Reserved:
      return "Reserved"
    case AssetStatus.Filling:
      return "Filling"
    case AssetStatus.DispatchReady:
      return "Dispatch Ready"
    case AssetStatus.Outbound:
      return "Outbound"
    case AssetStatus.Deployed:
      return "Deployed"
    case AssetStatus.Inbound:
      return "Inbound"
    case AssetStatus.DepotChecked:
      return "Depot Checked"
    case AssetStatus.Active:
      return "Active"
    case AssetStatus.Error:
      return "Error"
    case AssetStatus.Standby:
      return "Standby"
    case AssetStatus.Startup:
      return "Startup"
    case AssetStatus.Testing:
      return "Testing"
    case AssetStatus.Unreserved:
      return "Unreserved"
    default:
      return "Unknown"
  }
}
export const ORDERED_ASSET_STATUSES = [
  AssetStatus.Available,
  AssetStatus.Servicing,
  AssetStatus.Reserved,
  AssetStatus.Filling,
  AssetStatus.DispatchReady,
  AssetStatus.Outbound,
  AssetStatus.Deployed,
  AssetStatus.Inbound,
  AssetStatus.DepotChecked,
]

export const toStatusItems = (copy: TenantStatusCopy[]) => {
  if (copy.length > 0) {
    return ORDERED_ASSET_STATUSES.reduce((acc, status) => {
      const copyStatus = copy.find((c) => c.status === status)
      if (copyStatus) {
        acc.push({ label: copyStatus.value, value: status })
      }
      return acc
    }, [] as { label: string; value: AssetStatus }[])
  }
  return ORDERED_ASSET_STATUSES.map((status) => ({ label: statusToText(status), value: status }))
}
